import { render } from "./ShowTableData.vue?vue&type=template&id=1649615c"
import script from "./ShowTableData.vue?vue&type=script&lang=js"
export * from "./ShowTableData.vue?vue&type=script&lang=js"
script.render = render

export default script